import { render, staticRenderFns } from "./DeletedProposalsList.vue?vue&type=template&id=3d651e32&scoped=true&"
import script from "./DeletedProposalsList.vue?vue&type=script&lang=js&"
export * from "./DeletedProposalsList.vue?vue&type=script&lang=js&"
import style0 from "./DeletedProposalsList.vue?vue&type=style&index=0&id=3d651e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d651e32",
  null
  
)

export default component.exports